import Base from './base';

class DecisionSupport extends Base {
  fetchDecisionSupportQuotesRates = (accountId, groupId, payload) => {
    return this.apiClient.post(
      `accounts/${accountId}/groups/${groupId}/quotes/rates/decision_support`,
      payload,
    );
  };

  createDecisionSupportQuote = (accountId, groupId, payload) => {
    return this.apiClient.post(`accounts/${accountId}/groups/${groupId}/quotes`, payload);
  };

  getGroupDecisionSupportQuotes = (accountId, groupId, read_token) => {
    return this.apiClient.get(
      `accounts/${accountId}/groups/${groupId}/quotes?f[coverage_type]=decision_support${
        read_token ? `&token=${read_token}` : ''
      }`,
    );
  };

  updateDecisionSupportQuote = (accountId, groupId, quoteId, payload) => {
    return this.apiClient.put(`accounts/${accountId}/groups/${groupId}/quotes/${quoteId}`, payload);
  };

  deleteDecisionSupportQuote = (accountId, groupId, quoteId) => {
    return this.apiClient.delete(`accounts/${accountId}/groups/${groupId}/quotes/${quoteId}`);
  };

  getDecisionSupportQuotePlans = (accountId, groupId, quoteId, read_token) => {
    return this.apiClient.get(
      `accounts/${accountId}/groups/${groupId}/quotes/${quoteId}/plans${
        read_token ? `?token=${read_token}` : ''
      }`,
    );
  };
}

export default DecisionSupport;
